import React, { useState } from 'react'

export function DefinitionAnswerForm({ q, answer, onChange }) {
  const items = Array.isArray(q.payload?.items) ? q.payload.items : []
  const ansItems = Array.isArray(answer?.items) ? answer.items : []

  // Local state per item to completely decouple typing from parent re-renders
  const [localTexts, setLocalTexts] = useState(() =>
    items.map((_, idx) => (ansItems[idx]?.text != null ? ansItems[idx].text : ''))
  )

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {items.map((it, idx) => (
        <div key={idx} style={{ display: 'grid', gap: 6 }}>
          <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
            <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{idx + 1}-</div>
            <div style={{ color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.6, flex: 1 }}>
              {it?.term || '—'}
            </div>
          </div>
          <textarea
            value={localTexts[idx] || ''}
            onChange={e => {
              const nextTexts = [...localTexts]
              nextTexts[idx] = e.target.value
              setLocalTexts(nextTexts)
            }}
            onMouseDown={e => e.stopPropagation()}
            onBlur={e => {
              const next = [...ansItems]
              next[idx] = { text: e.target.value }
              onChange(q, { items: next })
            }}
            style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb', minHeight: 80, resize: 'vertical' }}
          />
        </div>
      ))}
    </div>
  )
}
